import "./login.scss"

// SSO routes
import { useMsal } from "@azure/msal-react"
import { loginRequest } from "../../authConfig"

// UI components
import { CosmosTitle, CosmosText, CosmosButton } from "@cosmos/web/react"
import VCARBLogo from "../../assets/images/racing-bulls.png"

// Returns the markup and functionality for logging a user in
export default function Login({}) {
	// Create a new instance of the Msal
	const { instance } = useMsal()

	// When the login button is pressed
	const handleLogin = () => {
		instance.loginPopup(loginRequest).catch((e) => {
			console.log(e)
		})
	}

	return (
		<div className="thosp-login-container">
			<img
				className="vcarb-logo"
				src={VCARBLogo}
			/>

			<CosmosTitle appearance="light">Trackside Hospitality</CosmosTitle>
			<CosmosText
				appearance="light"
				size="small"
				spacing="long-form-bottom">
				Please login below to continue.
			</CosmosText>

			<br />

			<CosmosButton
				onClick={() => handleLogin()}
				shape="rectangle">
				Login with SSO
			</CosmosButton>
		</div>
	)
}
